import React from 'react';
import { Col, Divider, Row } from 'antd';
import { isEqual } from 'lodash';

import {
  WorkerHistoryDetailsModel,
  WorkerHistoryRequest,
} from 'api/adminApiClient';
import { useAppDispatch } from 'hooks/useAppDispatch';
import HistoryField from '../../HistoryField';
import HistoryLog from '../../HistoryLog';
import { downloadFile, getFileNameWithoutExt } from 'utils/fileUtils';
import { getWorkerHistoryFile } from 'redux/reducers/workerSlice';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';

import styles from '../../HistoryCard.module.less';

type Props = {
  workerId?: string;
  historyDetails: WorkerHistoryDetailsModel;
  historyId: string;
};
export default function W9FormDetailsCard(props: Props) {
  const { historyDetails, workerId, historyId } = props;
  const { oldData, newData } = historyDetails;
  const dispatch = useAppDispatch();

  const hasWorkerFileKeyChanged = !isEqual(
    oldData?.workerFileKey || '',
    newData?.workerFileKey || '',
  );

  const handleDownloadAgreement = async (fileKey?: string) => {
    const result = await dispatch(
      getWorkerHistoryFile({
        workerId,
        fileKey,
      }),
    );

    if (getWorkerHistoryFile.fulfilled.match(result)) {
      try {
        await downloadFile({
          downloadUrl: result.payload.downloadUrl,
          fileName: result.payload.fileName,
        });
      } catch (e: any) {
        BaseAlert.error(e.message);
      }
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const renderW9Form = (worker?: WorkerHistoryRequest) => {
    if (!worker) return null;

    const { w9FileName, workerFileKey } = worker;
    const sectionName = 'w9';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>W9 form</div>
          </Col>
          {hasWorkerFileKeyChanged && (
            <HistoryField
              title="W9"
              emptyText="No file"
              value={
                w9FileName && (
                  <span
                    className="link-imitation"
                    onClick={() => handleDownloadAgreement(workerFileKey)}
                  >
                    {getFileNameWithoutExt(w9FileName)}
                  </span>
                )
              }
              dataId={`${sectionName}-file-field`}
            />
          )}
        </Row>

        <Divider />
      </>
    );
  };
  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderW9Form(oldData)}
      newData={renderW9Form(newData)}
    />
  );
}
